import { render, staticRenderFns } from "./allUserStorage.vue?vue&type=template&id=4fade9c6&scoped=true"
import script from "./allUserStorage.vue?vue&type=script&lang=js"
export * from "./allUserStorage.vue?vue&type=script&lang=js"
import style0 from "./allUserStorage.vue?vue&type=style&index=0&id=4fade9c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fade9c6",
  null
  
)

export default component.exports